import { render, staticRenderFns } from "./FavoriteFolderModal.vue?vue&type=template&id=08e22877"
import script from "./FavoriteFolderModal.vue?vue&type=script&lang=js"
export * from "./FavoriteFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports